import { TransitionColors } from '@grandvisionhq/lib-lime';
import { useFeatureToggles, useSelector } from '@grandvisionhq/state';
import { getSelectedAddOn } from '../../../state/configurator/selectors.js';

const LowerCasedTransitionColors = TransitionColors.map((s)=>s.toLowerCase()
);
function useTransitionColor() {
    const { isLimeEnabled  } = useFeatureToggles();
    const selectedAddOn = useSelector(getSelectedAddOn);
    if (!isLimeEnabled || !(selectedAddOn === null || selectedAddOn === void 0 ? void 0 : selectedAddOn.colorCode)) {
        return null;
    }
    const index = LowerCasedTransitionColors.indexOf(selectedAddOn.colorCode.toLowerCase());
    return index >= 0 ? TransitionColors[index] : null;
}

export { useTransitionColor };
//# sourceMappingURL=use-transition-color.js.map
